import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useParams, useNavigate } from "react-router-dom";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function EditProductionEntry() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [productionOrders, setProductionOrders] = useState([]);
  const [machines, setMachines] = useState([]);
  const [operators, setOperators] = useState([]);

  const [data, setData] = useState({
    production_id: "",
    machine_id: "",
    operator_id: "",
    produced_qty: "",
    rejected_qty: "0"
  });

  useEffect(() => {
    fetchEntry();
    fetchProductionOrders();
    fetchMachines();
    fetchOperators();
  }, []);

  const fetchEntry = () => {
    axios.get(baseUrl + "production-entry/" + id + "/")
      .then(res => {
        setData({
          production_id: res.data.production?.id || "",
          machine_id: res.data.machine?.id || "",
          operator_id: res.data.operator?.id || "",
          produced_qty: res.data.produced_qty,
          rejected_qty: res.data.rejected_qty
        });
      })
      .catch(() => Swal.fire("Error", "Could not fetch Production Entry", "error"));
  };

  const fetchProductionOrders = () => {
    axios.get(baseUrl + "production-orders/")
      .then(res => setProductionOrders(res.data));
  };

  const fetchMachines = () => {
    axios.get(baseUrl + "machines/")
      .then(res => setMachines(res.data));
  };

  const fetchOperators = () => {
    axios.get(baseUrl + "add-employee/")
      .then(res => setOperators(res.data));
  };

  const inputHandler = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const formSubmit = () => {
    if (!data.production_id || !data.machine_id || !data.operator_id || !data.produced_qty) {
      Swal.fire("Error", "All fields except Rejected Qty are required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("production", data.production_id);
    _formData.append("machine", data.machine_id);
    _formData.append("operator", data.operator_id);
    _formData.append("produced_qty", data.produced_qty);
    _formData.append("rejected_qty", data.rejected_qty || 0);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.put(baseUrl + "production-entry/" + id + "/", _formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then(response => {
      if (response.status === 200) {
        Swal.fire({
          title: "Production Entry Updated",
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });
        setTimeout(() => navigate('/production-entry'), 2000);
      }
    })
    .catch(() => Swal.fire("Error", "Update failed", "error"));
  };

  return (
    <div className="container mt-4">
      <div className="card p-4">
        <h4>Edit Production Entry</h4>

        <select
          name="production_id"
          value={data.production_id}
          onChange={inputHandler}
          className="form-control mt-3"
        >
          <option value="">Select Production Order</option>
          {productionOrders.map(po => (
            <option key={po.id} value={po.id}>
              {po.order_no} - {po.product?.name}
            </option>
          ))}
        </select>

        <select
          name="machine_id"
          value={data.machine_id}
          onChange={inputHandler}
          className="form-control mt-3"
        >
          <option value="">Select Machine</option>
          {machines.map(m => (
            <option key={m.id} value={m.id}>{m.name}</option>
          ))}
        </select>

        <select
          name="operator_id"
          value={data.operator_id}
          onChange={inputHandler}
          className="form-control mt-3"
        >
          <option value="">Select Operator</option>
          {operators.map(o => (
            <option key={o.id} value={o.id}>{o.employee}</option>
          ))}
        </select>

        <input
          type="number"
          className="form-control mt-3"
          name="produced_qty"
          placeholder="Produced Quantity"
          value={data.produced_qty}
          onChange={inputHandler}
        />

        <input
          type="number"
          className="form-control mt-3"
          name="rejected_qty"
          placeholder="Rejected Quantity"
          value={data.rejected_qty}
          onChange={inputHandler}
        />

        <button className="btn btn-primary mt-3" onClick={formSubmit}>
          Update
        </button>
      </div>
    </div>
  );
}

export default EditProductionEntry;
